<!-- 开发设置 --  数据迁移 -- 数据源设置编译 -->
<template>
  <basic-container>
    <div class="width-p100 bb-sm-primary mb-xxs pb-xs ds-fx flex-direction-row justify-content-start align-items-center">
      <i class="el-icon-document color-primary mr-sm"></i>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="link"><el-button type="text" @click="toParent">数据源设置</el-button></el-breadcrumb-item>
        <el-breadcrumb-item>数据源设置编译</el-breadcrumb-item>
        <el-breadcrumb-item>{{this.$route.query.sname}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row class="width-p100 ds-fx flex-direction-row align-items-center justify-content-start flex-wrap mb-none">
      <!-- 功能按钮区域 -->
      <el-col span="18" class="mb-xxs ds-fx flex-direction-row justify-content-start align-items-center">
        <el-button type="primary" size="mini" @click="blbyClick" icon="el-icon-magic-stick">全部编译</el-button>
      </el-col>
      <!-- 辅助按钮区域 -->
      <el-col span="6" class="mb-xxs ds-fx flex-direction-row justify-content-end align-items-center">
        <el-tooltip class="item" effect="dark" content="刷新" placement="top">
          <el-button icon="el-icon-refresh" size="mini" circle @click="onload"></el-button>
        </el-tooltip>
      </el-col>
    </el-row>
    <ux-grid ref="plxTable" :height='tableHeightFn()' size="mini" v-loading="loading" :data="data">
      <template v-for="(item,i) in column">
        <ux-table-column
          :key="i"
          resizable
          :field="item.prop"
          :title="item.label"
        >
        </ux-table-column>
      </template>
      <ux-table-column
        title="操作"
        resizable
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button icon="el-icon-magic-stick" type="text" size="mini" @click="rowBY(scope.row)">编译</el-button>
        </template>
      </ux-table-column>
    </ux-grid>
  </basic-container>
</template>

<script>
import { post } from '@/api/table/table';
export default {
  components: {},
  data() {
    return {
      data:[], // 数据
      column:[{
        prop:'OBJECT_NAME',
        label:'对象名称',
      },{
        prop:'OBJECT_TYPE',
        label:'对象类型',
      },{
        prop:'CREATED',
        label:'创建时间',
      },{
        prop:'LAST_DDL_TIME',
        label:'上次修改时间',
      }], // 配置
      firstEnter:true, // 配置
      loading:false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 请求数据
    onload(){
      this.loading=true;
      post("/api/blade-develop/usual/api/viewValidByPage",this.$qs.stringify({id:this.$route.query.id})).then(res=>{
        this.data=res.data.data;
        this.loading=false;
      })
    },
    // 行按钮 编译
    rowBY(row){
      this.loading=true;
      post("/api/blade-develop/usual/api/compile",this.$qs.stringify({
        id:this.$route.query.id,
        OBJECT_NAME:row.OBJECT_NAME,
        OBJECT_TYPE:row.OBJECT_TYPE,
      })).then(res=>{
        this.$message.success("编译成功!");
        this.loading=false;
      })
    },
    // 批量编译
    blbyClick(){
      this.loading=true;
      post("/api/blade-develop/usual/api/compile",this.$qs.stringify({
        id:this.$route.query.id,
      })).then(res=>{
        this.$message.success("全部编译成功!");
        this.loading=false;
      })
    },
    toParent(){
      this.$router.push({
        path:"/system/trans/dataSource",
        query:{
          runId:this.$route.query.runId,
          name:"数据源设置",
        }
      })
    },
    // 获取表格最大高度
    tableHeightFn(){
      let height=document.getElementById("avue-view");
      if(height){
        if(height.clientHeight>=558){
          return height.clientHeight-208;
        }else{
          return 350
        }
      }
    }
  },
  created() {},
  mounted() {},
  activated() {
    this.onload();
  },
};
</script>
<style lang="scss" scoped>
.link{
  /deep/ .el-breadcrumb__inner{
    color: #2E5AE8;
    cursor: pointer;
  }
  /deep/ .el-button{
    padding: 0;
  }
}
</style>
